document.addEventListener('DOMContentLoaded', () => {
  const galleryFields = document.querySelectorAll('[gallery-blog]');
  const sortSequence = [
    'all',
    'bmw',
    'toyota',
    'tesla',
    'subaru',
    'ford',
    'chevrolet',
    'hyundai',
    'genesis',
    'kia',
  ];
  function sortFilterItems() {
    galleryFields.forEach((dropdown) => {
      const filterList = dropdown.querySelector('.gallery-blog__filter-list');
      if (filterList) {
        const items = Array.from(filterList.children);
        items.sort((a, b) => {
          const aBrand = (a.getAttribute('data-brand') || '').toLowerCase();
          const bBrand = (b.getAttribute('data-brand') || '').toLowerCase();

          if (aBrand === 'all') return -1;
          if (bBrand === 'all') return 1;

          const aIndex = sortSequence.indexOf(aBrand);
          const bIndex = sortSequence.indexOf(bBrand);

          const aRank = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
          const bRank = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;

          if (aRank !== bRank) return aRank - bRank;

          return a.textContent.trim().localeCompare(b.textContent.trim(), undefined, { sensitivity: 'base' });
          });

        items.forEach((item) => filterList.appendChild(item));
      }
    });
  }
  sortFilterItems();
  galleryFields.forEach((dropdown) => {
    const brandSelectedField = dropdown.querySelector('[filter-brand-selected-field]');
    const modelSelectedField = dropdown.querySelector('[filter-model-selected-field]');
    const options = dropdown.querySelectorAll('[data-filter-item]');

    if (brandSelectedField) {
      brandSelectedField.addEventListener('click', (event) => {
        event.stopPropagation();

        const isOpen = dropdown.classList.contains('open');
        galleryFields.forEach((dd) => dd.classList.remove('open'));
        dropdown.classList.toggle('open', !isOpen);
      });
    }

    if (modelSelectedField) {
      modelSelectedField.addEventListener('click', (event) => {
        event.stopPropagation();

        const isOpen = dropdown.classList.contains('open');
        galleryFields.forEach((dd) => dd.classList.remove('open'));
        dropdown.classList.toggle('open', !isOpen);
      });
    }

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('open');
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.textContent.trim();
        const trigger = dropdown.querySelector('[filter-selected-value]');

        if (trigger) {
          trigger.textContent = value;
        }

        dropdown.classList.remove('open');

        const modelDisabledRemove = document.querySelector('[filter-model-selected-field]');
        if (modelDisabledRemove) {
          modelDisabledRemove.classList.remove('disabled');
        }

        if (dropdown.closest('[data-blog-filter-brand]')) {
          const selectedBrand = option.getAttribute('data-brand');
          brandSelectedField.classList.add('active');
          modelDisabledRemove.classList.remove('active');
          if (selectedBrand === 'all') {
            showAllItems();
          } else {
            filterModels(selectedBrand);
          }
        }

        if (dropdown.closest('[data-blog-filter-model]')) {
          const selectedModel = option.getAttribute('data-model');
          modelSelectedField.classList.add('active');
          filterArticles(selectedModel);
        }
      });
    });
  });

  function showAllItems() {
    const modelOptions = document.querySelectorAll('[data-blog-filter-model] [data-filter-item]');
    modelOptions.forEach((option) => option.classList.remove('hidden'));
    const modelTrigger = document.querySelector('[data-blog-filter-model] [filter-selected-value]');
    if (modelTrigger) {
      modelTrigger.textContent = 'Select a Model';
    }
    const articles = document.querySelectorAll('[data-article-brand], [data-article-model]');
    articles.forEach((article) => article.classList.remove('hidden'));
  }

  function filterModels(selectedBrand) {
    const modelOptions = document.querySelectorAll('[data-blog-filter-model] [data-filter-item]');

    modelOptions.forEach((option) => {
      const brandName = option.getAttribute('data-brand-name');
      if (brandName === selectedBrand) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    });

    const modelTrigger = document.querySelector('[data-blog-filter-model] [filter-selected-value]');
    if (modelTrigger) {
      modelTrigger.textContent = 'Select a Model';
    }

    filterArticlesByBrand(selectedBrand);
  }

  function filterArticlesByBrand(selectedBrand) {
    const articles = document.querySelectorAll('[data-article-brand]');

    articles.forEach((article) => {
      const articleBrand = article.getAttribute('data-article-brand');
      if (articleBrand === selectedBrand) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });
  }

  function filterArticles(selectedModel) {
    const articles = document.querySelectorAll('[data-article-model]');

    articles.forEach((article) => {
      const articleModel = article.getAttribute('data-article-model');
      if (articleModel === selectedModel) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });
  }
});